import { render, staticRenderFns } from "./VuebaseLayoutLogin.vue?vue&type=template&id=1520c12e&scoped=true"
import script from "./VuebaseLayoutLogin.vue?vue&type=script&lang=js"
export * from "./VuebaseLayoutLogin.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayoutLogin.vue?vue&type=style&index=0&id=1520c12e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520c12e",
  null
  
)

export default component.exports